import { HtBaseNode, HtNodeLink } from './common'
import { HtNodeWithContentType } from './node-types'

export enum HtArgumentType {
  NUMBER = 'number',
  STRING = 'string',
  BOOLEAN = 'boolean',
  JSON = 'json',
}

export interface HtFunctionArgument {
  type: HtArgumentType
  name: string
  value: string | number | boolean
}

export interface HtFunctionArgumentLocale {
  locale: string
  values: HtFunctionArgument[]
}

export interface HtFunctionResult {
  result: string | number | boolean
  target?: HtNodeLink
}

export interface HtFunctionNode extends HtBaseNode {
  type: HtNodeWithContentType.FUNCTION
  content: {
    action: string
    arguments: (HtFunctionArgumentLocale | HtFunctionArgument)[]
    result_mapping: HtFunctionResult[]
  }
}
